export const DEFAULT_LOCALE = 'en'
export const SUPPORTED_LOCALES = ['en', 'zh-cn', 'zh-tw']

export const normalizeLocale = locale => String(locale || '').toLowerCase()

export const isSupportedLocale = locale => SUPPORTED_LOCALES.includes(normalizeLocale(locale))

export const getLocaleFromPath = (path = window.location.pathname) => {
  const segment = String(path || '').split('/').filter(Boolean)[0]
  return isSupportedLocale(segment) ? normalizeLocale(segment) : ''
}
